import { Injectable } from '@angular/core';
import { AdminGeneratedService } from '../AdminService/admin-service-generate';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class DocumentDownloadService {

  constructor() { }

  convertbase64toArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }

  finalDownloadDocument(content, type?, fileName?) {
    var FileSaver = require('file-saver');
    var byteArr = this.convertbase64toArrayBuffer(content);
    var blob = new Blob([byteArr], { type: 'application/' + type });
    FileSaver.saveAs(blob, fileName);
  }
}
